export default "__VITE_ASSET__DrDGCjXK__"